export const applicationConfig = {
  apiUrl: process.env.REACT_APP_API_URL,
  azureADClientId: process.env.REACT_APP_AAD_CLIENT_ID,
  azureADTenantId: process.env.REACT_APP_AAD_TENANT_ID,
  azureADAPIScopeURI: process.env.REACT_APP_AAD_API_SCOPE_URI,
  apiTimeoutMs: 30000,
};
